import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { responsiveCard } from "../../utils/responsive";

export const qrStyle = recipe({
  base: {
    aspectRatio: "1/1",
    width: rem(160),
    flexShrink: 0,
    margin: "0 auto",
    overflow: "visible",
    "::before": {
      content: "''",
      position: "absolute",
      top: `calc(${theme.spacings.xs} / 2 * -1)`,
      left: `calc(${theme.spacings.xs} / 2 * -1)`,
      width: `calc(100% + ${theme.spacings.xs})`,
      height: `calc(100% + ${theme.spacings.xs})`,
      backgroundColor: "#fff",
      borderRadius: theme.borderRadiuses.xxs,
      zIndex: -1,
    },
  },
  variants: {
    loading: {
      true: {
        borderRadius: theme.borderRadiuses.s,
        "::before": {
          backgroundColor: "transparent",
        },
      },
    },
  },
  defaultVariants: {},
});

export const titleContainerStyle = style({
  flexDirection: "column-reverse",
  ...responsiveCard({
    600: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
  }),
});

export const contentStyle = style({
  gap: theme.spacings.l,
  alignItems: "flex-start",
  flexDirection: "column",
  ...responsiveCard({
    600: {
      flexDirection: "row",
    },
  }),
});

export const titleTrailingStyle = style({
  flexShrink: 0,
  flexGrow: 0,
});
